<header class="bc-navbar">
  <div class="menu-top">
    <div class="header-item header-logo" title="{{ branding?.logo?.title }}" data-automation-id="BoldLogo">
      <svg-icon icon="{{ branding?.logo?.icon }}"></svg-icon>
    </div>
  </div>

  <div class="menu-bottom">
    <div class="header-item" [ngClass]="{'bottom-spacer': (isHybrid | async) === false}" *ngIf="isLoggedIn">
      <app-audio-settings></app-audio-settings>
    </div>

    <div *ngIf='(isHybrid | async) && isLoggedIn' class="horizontal-line-spacer"></div>

    <ng-container *ngIf="isLoggedIn">
      <div *ifFeatureEnabled="'gc.dxChat'" class="header-item header-item-auto">
        <app-genesys-presence-button [isHybrid]='isHybrid | async'></app-genesys-presence-button>
      </div>
    </ng-container>

    <div *ngIf='(isHybrid | async) && isLoggedIn' class="horizontal-line-spacer"></div>

    <div class="header-item header-item-auto" *ngIf="isLoggedIn">
      <app-operator-status-buttons></app-operator-status-buttons>
    </div>

    <div class="header-item header-user-menu">
      <app-user-menu-button [initial]="initial"
                            [isBoldEnabled]="isBoldEnabled | async"
                            [isHybrid]="isHybrid | async"
                            [isLoggedIn]="isLoggedIn"
                            [isRecordingsEnabled]="isListRecordingsEnabled"
                            [helpLink]="branding?.links?.help"
                            [canChangePassword]="canChangePassword"
                            [isUserWithMultipleAccount]="isUserWithMultipleAccount"
                            [username]="username"
                            (openUrl)="openUrl($event)"
                            (selectSettings)="openSettingsMenu()"
                            (selectRecordings)="goToRecordingsPage()"
                            (selectSwitchAccount)="switchAccount()"
                            (selectChangePassword)="openChangePassword()"
                            (selectLogout)="logout()">
      </app-user-menu-button>
      <div #tooltip="matTooltip" matTooltip="{{ 'bcNavbar.confirmationPanelSetting' | translate }}" matTooltipPosition="right" [matTooltipClass]="'tooltip-class'"></div>
    </div>
  </div>
</header>
